// extracted by mini-css-extract-plugin
export default {"hero":"CardHero-module--hero--f80cf"};